import { networkClient } from './client';
import type { ApiEnvelope } from './types';

export type AppSettings = {
  transfersEnabled: boolean;
  substitutionsEnabled: boolean;
  captaincyChangesEnabled: boolean;
  /** Admin toggle for the "your team is updating" between-gameweeks pop-up. */
  teamTransitionPopupEnabled: boolean;
};

export type AppSettingsResponse = ApiEnvelope<AppSettings>;

export const fetchAppSettings = (): Promise<AppSettingsResponse> =>
  networkClient.get<AppSettingsResponse>('/api/app-settings').then(({ data }) => data);
